module.exports = __webpack_public_path__ + "static/media/signature.69529d83.svg";